// Listed up front; the view itself (./chord-finder.tsx) and its chord book load on demand.
export const id = 'chord-finder';
export const title = 'Chord finder';
export const order = 30;
